import { adminMyThemeQuery } from 'graphql/queries';
import { useQuery } from '@apollo/react-hooks';
import { grabFirstGQLDataResult } from 'utils/helpers';
import { useRef } from 'react';

export const useTheme = () => {
  const { data, loading } = useQuery(adminMyThemeQuery);
  const themeRef = useRef();
  const theme = grabFirstGQLDataResult(data)?.pdf;
  if (!loading) themeRef.current = theme;
  return { loading, theme: themeRef.current };
};

export default useTheme;
